<div #backdrop class="backdrop t-all" (click)="closeModal()"></div>
<div class="content-box" #contentWrapper>
  <div class="close-button">
    <button class="back-link" *ngIf="!closeBlocking" (click)="closeModal()">
      <i class="custom-icon custom-icon-cancel-search"></i>
    </button>
  </div>
  <ng-container #content></ng-container>
</div>
